import { ResponsiveColor, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography, TypographyFontSize } from '@genial/design-tokens';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { masterState } from '../../../../../../store/master/atom';
import { sessionState } from '../../../../../../store/session/atom';

interface HelloProps {
  isMobile?: boolean;
}

export const Hello: React.FC<HelloProps> = ({ isMobile }) => {
  const { userProfile } = useRecoilValue(sessionState);
  const { selectedAdvisorName } = useRecoilValue(masterState);
  const textColor: ResponsiveColor = { base: 'neutral.medium', sm: 'brand.primary.darkest' };

  const currentProfileName = selectedAdvisorName || userProfile?.nomeRecurso;

  return (
    <VStack flex={1}>
      {isMobile ? (
        <VStack space={Spacing['stack.nano']}>
          <HStack space={Spacing['stack.quarck']}>
            <Text flex={1} fontSize={TypographyFontSize.xl} color={'neutral.dark'}>
              Olá, {currentProfileName?.trim().split(' ')[0]}!
            </Text>
          </HStack>
          <Text fontSize={TypographyFontSize.md} color={textColor}>
            Tenha uma visão ampla do desempenho financeiro em nosso painel de controle.
          </Text>
        </VStack>
      ) : (
        <>
          <HStack space={Spacing['stack.quarck']}>
            <Text
              flex={1}
              fontSize={TypographyFontSize.xxl}
              color={textColor}
              fontFamily={Typography['fontfamily.base.regular']}>
              Olá, {currentProfileName?.trim().split(' ')[0]}!
            </Text>
          </HStack>
          <Text fontSize={TypographyFontSize.lg} color={'neutral.dark'} marginTop={1}>
            Tenha uma visão ampla do desempenho financeiro em nosso painel de controle.
          </Text>
        </>
      )}
    </VStack>
  );
};
